import sessionsTranslations from './sessions.en.json'
import catalogsTranslations from './catalogs.en.json'
import categoriesTranslations from './categories.en.json'
import organizationsTranslations from './organizations.en.json'
import errorsTranslations from './errors.en.json'
import globalTranslations from './global.en.json'
import materialModelsTranslations from './materialModels.en.json'
import carbonModelsTranslations from './carbonModels.en.json'
import materialsTranslations from './materials.en.json'
import ordersTranslations from './orders.en.json'
import usersTranslations from './users.en.json'
import requestsTranslations from './requests.en.json'
import reportsTranslations from './reports.en.json'
import chatsTranslations from './chats.en.json'
import inventoryChecksTranslations from './inventoryChecks.en.json'

const EN = {
  chats: chatsTranslations,
  catalogs: catalogsTranslations,
  categories: categoriesTranslations,
  organizations: organizationsTranslations,
  errors: errorsTranslations,
  global: globalTranslations,
  materialModels: materialModelsTranslations,
  carbonModels: carbonModelsTranslations,
  materials: materialsTranslations,
  orders: ordersTranslations,
  users: usersTranslations,
  requests: requestsTranslations,
  sessions: sessionsTranslations,
  reports: reportsTranslations,
  inventoryChecks: inventoryChecksTranslations,
}

export default EN
